export default "\r\n<app-exchange-rate-list></app-exchange-rate-list>\r\n\r\n\r\n";